export default __webpack_public_path__ + "static/media/CheckSuccess.af20b581.svg";